import React, { useState, useEffect } from "react";
import Chat from "../components/common/Chat";
import Toolbar from "../navigation/Toobar";
import Header from "../layout/Header";

function Transaction({transactionData}){
    const [statusFilter, setStatusFilter] = useState("All");
    const [paymentTypeFilter, setPaymentTypeFilter] = useState("All");
    const [dateFilter, setDateFilter] = useState("Last 7 days");
    const [isCurrentTab, setIsCurrentTab] = useState(true);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
	const [isFilterOpen, setIsFilterOpen] = useState(false);

    // Open/close filter modal
    const openFilter = () => setIsFilterOpen(true);
    const closeFilter = () => setIsFilterOpen(false);

    // Open/close transaction details popup
    const openPopup = (transaction) => setSelectedTransaction(transaction);
    const closePopup = () => setSelectedTransaction(null);

    // Toggle between tabs in transaction details
    const toggleTab = () => setIsCurrentTab(!isCurrentTab);
    

    const handleStatusFilterChange = (status) => {
        setStatusFilter(status);
      };
    
      const handleActionFilterChange = (action) => {
        setPaymentTypeFilter(action);
      };
    
      const handleDateFilterChange = (dateRange) => {
        setDateFilter(dateRange);
      };

    

    

    // Helper function to check if a date is in a specific range
    const isDateInRange = (date, range) => {
        const today = new Date();
        const txnDate = new Date(date);
    
        if (range === "Today") {
            return txnDate.toDateString() === today.toDateString();
        } else if (range === "Yesterday") {
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            return txnDate.toDateString() === yesterday.toDateString();
        } else if (range === "Last 7 days") {
            const lastWeek = new Date(today);
            lastWeek.setDate(today.getDate() - 7);
            return txnDate >= lastWeek && txnDate <= today;
        }
        return true;
    };

	// Apply selected filters to transactions
	if (transactionData?.message) { 
		transactionData = [];
	}
	
    const filteredTransactions = transactionData.filter((transaction) => {
        const isStatusMatch =
            statusFilter === "All" ||
            (statusFilter === "Success" && transaction.key === "1") ||
            (statusFilter === "Pending" && transaction.key === "0") ||
            (statusFilter === "Fail" && transaction.key === "2");
    
        const isPaymentTypeMatch =
            paymentTypeFilter === "All" ||
            (paymentTypeFilter === "Deposit" && transaction.action === "deposit") ||
            (paymentTypeFilter === "Withdrawal" && transaction.action === "withdraw");
    
        const isDateMatch = isDateInRange(transaction.created_at, dateFilter);
    
        return isStatusMatch && isPaymentTypeMatch && isDateMatch;

        
    });

    // Group transactions by date for display
    const groupedTransactions = filteredTransactions.reduce((grouped, transaction) => {
        const date = new Date(transaction.created_at).toDateString();
        if (!grouped[date]) grouped[date] = [];
        grouped[date].push(transaction);
        return grouped;
    }, {});


    return(
        <div className="v-application--wrap">
  <div>
    
    <div className="row no-gutters">
        <Header/>
    </div>
    <div className="body">
      <div style={{overflow: 'hidden'}}>
        <div className="row hidden-md-and-up" style={{height: '75px'}}>
          <div className="mobile-header text-center white--text col col-12">
           Wallet History
          </div>
        </div>
        
        <div className="row">
          <div className="historyContainer col col-12">
            <div>
               {Object.keys(groupedTransactions).length > 0 ? (
                        Object.keys(groupedTransactions).map((date, idx) => (
              <div className="desktop_card_history pt-3 v-card v-sheet theme--light elevation-0">
                <div className="bank-detail-card history-card v-card v-sheet theme--light elevation-0">
                  <div className="row no-gutters">
                     {groupedTransactions[date].map((transaction, index) => (
                    <div className="col col-12">
                      <div className="row mobile-history-table">
                        <div className="mr-0 col col-6">
                          <div className="row referral-table-header pl-6 no-gutters">
                            <div className="col col-12">
                              Date
                            </div>
                            <div className="col col-12">
                              {transaction.action} Method
                            </div>
                            <div className="col col-12">
                              Payment Channel
                            </div>
                            <div className="col col-12">
                              {transaction.action} ID
                            </div>
                            <div className="col col-12">
                              {transaction.action} Amount
                            </div>
                            <div className="col col-12">
                              Bonus
                            </div>
                            <div className="col col-12">
                              Status
                            </div>
                            <div className="col col-12">
                              Remarks
                            </div>
                          </div>
                        </div>
                        <div className="col col-6">
                          <div className="row no-gutters">
                            <div className="col col-12">
                              {transaction.created_at}
                            </div>
                            <div className="col col-12">
                              {transaction.provider}
                            </div>
                            <div className="col col-12">
                              DPay
                            </div>
                            <div className="col col-12">
                              {transaction.transaction_id}
                              
                            </div>
                            <div className="col col-12">
                              ৳ {transaction.amount}
                            </div>
                            <div className="col col-12"><label>{transaction.promotion?.name || ''}</label></div>
                            <div className="col col-12">
                              <span>{Number(transaction.key) === 1 ? "Success" : Number(transaction.key) === 2 ? "Fail" : "Processing"}</span>
                              <button type="button" className="checkButton px-1 mx-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--small primary">
                                <span className="v-btn__content">
                                  button.checkStatus
                                </span>
                              </button>
                            </div>
                            <div className="col col-12"><label>-</label></div>
                          </div>
                        </div>
                        <div className="col col-12"><hr role="separator" aria-orientation="horizontal" className="mx-2 v-divider theme--light" /></div>
                      </div>
                    </div>
                     ))}


                  </div>
                  
                </div>
                {/**/}
              </div>
                ))
                    ) : (
                       <p>No Data</p>
                    )}
              
            </div>
          </div>
        </div>
      </div>
      {/**/}
    </div>
   <Toolbar/>
   <Chat/>
  </div>
</div>

    );

}
export default Transaction;